var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('cv-toast-notification',{staticClass:"small-details-notification",attrs:{"title":_vm.$t(`small-details.header.bad`),"sub-title":_vm.data.fileName,"caption":_vm.$tc(`validators.SMALL_DETAILS_VALIDATOR_MSG`, 1, {
      status: _vm.validatorColorTranslation(),
    }),"kind":_vm.kind,"hide-close-button":_vm.kind === 'error',"low-contrast":false},on:{"close":function($event){_vm.isVisible = false}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }